var PromocodesCollection = (function (Collection, VoucherItem) {
	return Collection.extend({
		model: VoucherItem
	});
})(CheckoutApiCollection, VoucherItem);
